import InboxRequirementBoardDropdown from "./RequirementBoardDropdown";
import InboxSolutionsDropdown from "./RequirementSolutionsDropdown";

const TitleMap = (pathname, userType) => {
  const titles = {
    '/dashboard': 'Dashboard',
    '/bsi-co-lab': 'BSI Co-lab',
    '/bsi-co-lab-requirements': 'BSI Co-lab',
    '/bsi-co-lab/kanban': 'BSI Co-lab',
    '/invite-solution-provider': 'BSI Co-lab',
    '/manage-users': 'Manage Users',
    '/edit-team-members': 'Manage Team Members',
    '/inbox': userType === 'solution_provider' ? <InboxSolutionsDropdown /> : <InboxRequirementBoardDropdown />,
    '/bsi-drive': 'BSI Drive',
    '/bsi-sub-drive': 'BSI Drive',
    '/meetings': 'Meetings',
    '/profile': 'Profile',
    '/profile-business': 'Profile',
    '/my-solutions': 'My Solutions',
    '/edit-solution-details': 'My Solutions',
    '/solution-investment-summary': 'My Solutions',
    '/solution-enquiries': 'BSI Co-lab',
    '/kanban-solution-enquiries': 'BSI Co-lab',
    '/investment-enquiries': 'BSI Co-lab',
    '/kanban-investment-enquiries': 'BSI Co-lab',
    '/portfolio': 'Portfolio',
    '/manage-subscription' : 'Manage Subscription',
    '/add-project' : 'Add Project',
    '/projects' : 'Projects',
    '/project-detail' : "Project Detail",
    '/add-mile-stone' : "Milestone",
    '/edit-mile-stone' : "Milestone"
  };

  return titles[pathname] || '';
};

export default TitleMap;
